import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecp-login-page',
  templateUrl: './ecp-login-page.component.html',
  styleUrls: ['./ecp-login-page.component.css']
})
export class EcpLoginPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
